import { SingletonList } from "../../../../utils/SingletonList";
export class WebSceneRenderManager {
    constructor() {
        this._list = new SingletonList();
        this.baseRenderList = new SingletonList();
    }
    get list() {
        return this._list;
    }
    set list(value) {
        this._list = value;
        let elemnt = this._list.elements;
        this.baseRenderList.clear();
        for (let i = 0; i < this._list.length; i++) {
            this.baseRenderList.add(elemnt[i]._baseRenderNode);
        }
    }
    addRenderObject(object) {
        this._list.add(object);
        this.baseRenderList.add(object._baseRenderNode);
    }
    removeRenderObject(object) {
        this._list.remove(object);
        this.baseRenderList.remove(object._baseRenderNode);
    }
    removeMotionObject(object) {
    }
    updateMotionObjects() {
    }
    addMotionObject(object) {
    }
    destroy() {
        this._list.destroy();
        this.baseRenderList.destroy();
        this._list = null;
        this.baseRenderList = null;
    }
}
